import { HttpClient } from "@angular/common/http";
import { TranslateLoader } from "@ngx-translate/core";
import { Observable, of } from "rxjs";
import { I18nService } from "./i18n.service";
import { combineLatest } from 'rxjs';
import { catchError, delay, map } from "rxjs/operators";

export class MoptaxTranslateLoader implements TranslateLoader {


    constructor(
        private i18nService: I18nService
    ) { }


    public getTranslation(lang: string): Observable<Object> {
        return this.i18nService.fetchTranslations(lang)
            .pipe(
                catchError(() => of({}))
            )
    }


}